import React from 'react'
// libs
import styled from 'styled-components'
import { useRouter } from 'hooks/useRouter'
import { useDispatch } from 'react-redux'
import { useMutation } from '@apollo/client/react'
import { clearAccessToken } from 'lib/auth'
// hooks
import { useApolloClient } from 'hooks/useApolloClient'
// components
import { Button } from 'components/UI'
import { BUTTON_LAYOUTS } from 'components/UI/Button'
import MenuItemOrigin from '@mui/material/MenuItem'
// graphql
import { AUTH_SIGN_OUT_MUTATION } from 'graphql/auth/mutations'
// providers
import { authChannel } from 'providers/SessionProvider/utils'
import { AuthChannelEvent } from 'providers/SessionProvider/constants'
// store
import { LOGOUT_ACTION } from 'store/types'
// utils
import { markManualLogout } from 'utils/authStorage'

const MenuItem = styled(MenuItemOrigin)`
  && {
    cursor: pointer;
    min-height: 40px;
    padding: 0 16px;
  }
`

interface Props {
  isButton?: boolean
}

const LogOut: React.FC<Props> = ({ isButton = false }) => {
  const router = useRouter()
  const dispatch = useDispatch()

  const { client } = useApolloClient()

  const [signOutMt] = useMutation(AUTH_SIGN_OUT_MUTATION)

  const onLogoutClick = async () => {
    try {
      await signOutMt()
      await client.clearStore()
    } catch {
      // ignore — proceed with local cleanup even if server call fails
    }

    authChannel?.postMessage({ type: AuthChannelEvent.LOGOUT })
    clearAccessToken()
    dispatch({ type: LOGOUT_ACTION })
    localStorage.clear()
    markManualLogout()
    router.push('/login')
  }

  return isButton ? (
    <Button shadowLess onClick={onLogoutClick} layout={BUTTON_LAYOUTS.PURPLE} data-testid='logout-menu-item'>
      Log out
    </Button>
  ) : (
    <MenuItem onClick={onLogoutClick} data-testid='logout-menu-item'>
      Log out
    </MenuItem>
  )
}

export default LogOut
